import grapesjs from "grapesjs";
import gjsBlockBasic from "grapesjs-blocks-basic";
import $ from "jquery";
import grapesjsBlockBootstrap from "grapesjs-blocks-bootstrap4";
import grapesjsPluginExport from "grapesjs-plugin-export";
import grapesjsStyleBg from "grapesjs-style-bg";
import CKEDITOR from 'ckeditor/ckeditor'
import { CKEditor } from "@ckeditor/ckeditor5-react";
import 'grapesjs-plugin-ckeditor';
import plugin from 'grapesjs-rte-extensions';
import AboutPlugin from '../plugins/about/AboutPlugin';
import MenuPlugin from '../plugins/menu/MenuPlugin';
import {
  addEditorCommand,
  deviceManager,
  layerManager,
  panels,
  scripts,
  selectorManager,
  storageSetting,
  styleManager,
  styles,
  toggleSidebar,
  traitManager,
} from "./geditor_utils";
import tailwindComponent from "../plugins/tailwind";
import swiperComponent from "../plugins/swiper";
import chartLibComponent from "../plugins/charts";
// const geditorConfig = (assets, pageId,templateId,flag) => {
// if(assets.length>0){
//   // if(flag==1){
//   //   pageId=templateId;
//   // }
//   geditorConfigSan (assets, pageId,flag,templateId);
// }
// }
const geditorConfig = (assets, pageId,templateId,flag) => {
  $(".panel__devices").html("");
  $(".panel__basic-actions").html("");
  $(".panel__editor").html("");
  $("#blocks").html("");
  $("#styles-container").html("");
  $("#layers-container").html("");
  $("#trait-container").html("");

console.log(assets);
  // Content for Preview
  const navbar = $("#navbar");
  const mainContent = $("#main-content");
  const panelTopBar = $("#main-content > .navbar-light");

  const editor = grapesjs.init({
    container: "#editor",
    blockManager: {
      appendTo: "#blocks",
      //  blocks: templates,
    },
    styleManager: styleManager,
    layerManager: layerManager,
    traitManager: traitManager,
    selectorManager: selectorManager,
    panels: panels,
    deviceManager: deviceManager,
    assetManager: { assets: assets,  upload: 'https://endpoint/upload/assets',

    // The name used in POST to pass uploaded files, default: `'files'`
    uploadName: 'files' },
    storageManager: storageSetting(pageId,flag,templateId),
    canvas: {
      styles: styles,
      scripts: scripts,
    },
    plugins: [
      tailwindComponent,
      gjsBlockBasic,
      swiperComponent,
      grapesjsBlockBootstrap,
      grapesjsPluginExport,
      grapesjsStyleBg,
      chartLibComponent,
      // plugin,
      'grapesjs-plugin-ckeditor'
    ],
    pluginsOpts: {
      tailwindComponent: {},
      gjsBlockBasic: {},
      swiperComponent: {},
      grapesjsBlockBootstrap: {},
      grapesjsPluginExport: {},
      grapesjsStyleBg: {},
      chartLibComponent: {},
      // plugin: {
      // },
      'gjs-plugin-ckeditor' : {
        options: {
                language: 'en',
                uiColor: '#131414',
                toolbarGroups: [
                  { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                  { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                  { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                  { name: 'forms', groups: [ 'forms' ] },
                  '/',
                  { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                  { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
                  { name: 'links', groups: [ 'links' ] },
                  { name: 'insert', groups: [ 'insert' ] },
                  '/',
                  { name: 'styles', groups: [ 'styles' ] },
                  { name: 'colors', groups: [ 'colors' ] },
                  { name: 'tools', groups: [ 'tools' ] },
                  { name: 'others', groups: [ 'others' ] },
                  { name: 'about', groups: [ 'about' ] }
                ],
                removeButtons: 'NewPage'
              },
      }
    },
  });
  editor.trigger('test:canvasOffset');
  editor.trigger('frame:updated');
  editor.refresh();
  editor.DomComponents.clear(); // Clear components
  editor.CssComposer.clear();  // Clear styles
  editor.UndoManager.clear(); // Clear undo history
  editor.setComponents([{}, {}]) // Add components
  editor.setStyle([{}, {}]) // Add rules

  addEditorCommand(editor);
  if(flag==0){
  editor.addComponents(`<!DOCTYPE html>
  <html>
  <head>
  <title>W3.CSS Template</title>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css">
  <style>
  body {font-family: "Times New Roman", Georgia, Serif;}
  h1, h2, h3, h4, h5, h6 {
    font-family: "Playfair Display";
    letter-spacing: 5px;
  }
  </style>
  </head>
  <body>
  
  <!-- Navbar (sit on top) -->
  <div class="w3-top">
    <div class="w3-bar w3-white w3-padding w3-card" style="letter-spacing:4px;">
      <a href="#home" class="w3-bar-item w3-button">Gourmet au Catering</a>
      <!-- Right-sided navbar links. Hide them on small screens -->
      <div class="w3-right w3-hide-small">
        <a href="#about" class="w3-bar-item w3-button">About</a>
        <a href="#menu" class="w3-bar-item w3-button">Menu</a>
        <a href="#contact" class="w3-bar-item w3-button">Contact</a>
      </div>
    </div>
  </div>
  
  <!-- Header -->
  <header class="w3-display-container w3-content w3-wide" style="max-width:1600px;min-width:500px" id="home">
    <img class="w3-image" src="https://www.w3schools.com/w3images/hamburger.jpg" alt="Hamburger Catering" width="1600" height="800">
    <div class="w3-display-bottomleft w3-padding-large w3-opacity">
      <h1 class="w3-xxlarge">Le Catering</h1>
    </div>
  </header>
  
  <!-- Page content -->
  <div class="w3-content" style="max-width:1100px">
  
    <!-- About Section -->
    <div class="w3-row w3-padding-64" id="about">
      <div class="w3-col m6 w3-padding-large w3-hide-small">
       <img src="https://www.w3schools.com/w3images/tablesetting2.jpg" class="w3-round w3-image w3-opacity-min" alt="Table Setting" width="600" height="750">
      </div>
  
      <div class="w3-col m6 w3-padding-large">
        <h1 class="w3-center">About Catering</h1><br>
        <h5 class="w3-center">Tradition since 1889</h5>
        <p class="w3-large">The Catering was founded in blabla by Mr. Smith in lorem ipsum dolor sit amet, consectetur adipiscing elit consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute iruredolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.We only use <span class="w3-tag w3-light-grey">seasonal</span> ingredients.</p>
        <p class="w3-large w3-text-grey w3-hide-medium">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum consectetur adipiscing elit, sed do eiusmod temporincididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
      </div>
    </div>
    
    <hr>
    
    <!-- Menu Section -->
    <div class="w3-row w3-padding-64" id="menu">
      <div class="w3-col l6 w3-padding-large">
        <h1 class="w3-center">Our Menu</h1><br>
        <h4>Bread Basket</h4>
        <p class="w3-text-grey">Assortment of fresh baked fruit breads and muffins 5.50</p><br>
      
        <h4>Honey Almond Granola with Fruits</h4>
        <p class="w3-text-grey">Natural cereal of honey toasted oats, raisins, almonds and dates 7.00</p><br>
      
        <h4>Belgian Waffle</h4>
        <p class="w3-text-grey">Vanilla flavored batter with malted flour 7.50</p><br>
      
        <h4>Scrambled eggs</h4>
        <p class="w3-text-grey">Scrambled eggs, roasted red pepper and garlic, with green onions 7.50</p><br>
      
        <h4>Blueberry Pancakes</h4>
        <p class="w3-text-grey">With syrup, butter and lots of berries 8.50</p>    
      </div>
      
      <div class="w3-col l6 w3-padding-large">
        <img src="https://www.w3schools.com/w3images/tablesetting.jpg" class="w3-round w3-image w3-opacity-min" alt="Menu" style="width:100%">
      </div>
    </div>
  
    <hr>
  
    <!-- Contact Section -->
    <div class="w3-container w3-padding-64" id="contact">
      <h1>Contact</h1><br>
      <p>We offer full-service catering for any event, large or small. We understand your needs and we will cater the food to satisfy the biggerst criteria of them all, both look and taste. Do not hesitate to contact us.</p>
      <p class="w3-text-blue-grey w3-large"><b>Catering Service, 42nd Living St, 43043 New York, NY</b></p>
      <p>You can also contact us by phone 00553123-2323 or email catering@catering.com, or you can send us a message here:</p>
      <form action="/action_page.php" target="_blank">
        <p><input class="w3-input w3-padding-16" type="text" placeholder="Name" required name="Name"></p>
        <p><input class="w3-input w3-padding-16" type="number" placeholder="How many people" required name="People"></p>
        <p><input class="w3-input w3-padding-16" type="datetime-local" placeholder="Date and time" required name="date" value="2020-11-16T20:00"></p>
        <p><input class="w3-input w3-padding-16" type="text" placeholder="Message \ Special requirements" required name="Message"></p>
        <p><button class="w3-button w3-light-grey w3-section" type="submit">SEND MESSAGE</button></p>
      </form>
    </div>
    
  <!-- End page content -->
  </div>
  
  <!-- Footer -->
  <footer class="w3-center w3-light-grey w3-padding-32">
    <p>Powered by <a href="https://www.w3schools.com/w3css/default.asp" title="W3.CSS" target="_blank" class="w3-hover-text-green">w3.css</a></p>
  </footer>
  
  </body>
  </html>
  `);
}
  editor.on("run:preview", () => {
    console.log("It will trigger when we click on preview icon");
    // This will be used to hide border
    editor.stopCommand("sw-visibility");
    // This will hide the sidebar view
    navbar.removeClass("sidebar");
    // This will make the main-content to be full width
    mainContent.removeClass("main-content");

    // This will hide top panel where we have added the button
    panelTopBar.addClass("d-none");
  });
  editor.on("stop:preview", () => {
    // This event is reverse of the above event.
    console.log("It will trigger when we click on cancel preview icon");
    editor.runCommand("sw-visibility");
    navbar.addClass("sidebar");
    mainContent.addClass("main-content");
    panelTopBar.removeClass("d-none");
  });
  editor.on("component:selected", (component) => {
    const newTool = {
      icon: "fa fa-plus-square",
      title: "Check Toolbar",
      commandName: "new-tool-cmd",
      id: "new-tool",
    };

    const defaultToolbar = component.get("toolbar");
    const checkAlreadyExist = defaultToolbar.find(
      (toolbar) => toolbar.command === newTool.commandName
    );
    if (!checkAlreadyExist) {
      defaultToolbar.unshift({
        id: newTool.id,
        attributes: { class: newTool.icon, title: newTool.title },
        command: newTool.commandName,
      });
      component.set("toolbar", defaultToolbar);
    }
  });

  setTimeout(() => {
    let categories = editor.BlockManager.getCategories();
    console.log(categories);
    categories.each((category) => category.set("open", false));
  }, 3000);
  return editor;
};

export default geditorConfig;
